import Api from '@/services/Api'

const HEADERURL = 'compras/cotizacion/';
const ACTION_ADD_DETAIL = 'agregar_detalle';
const ACTION_DELETE_DETAIL = 'eliminar_detalle';
const ACTION_PARA_COMPRAR = 'para_comprar';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';
const IMPIRMIR_PDF = 'pdf';
const ACTION_GENERAR_ORDEN_COMPRA = 'generar_orden_compra';
const ACTION_AUTORIZAR_LINEA= 'autorizar_detalle';
const ACTION_AUTORIZAR_TODO= 'autorizar_cotizaciones';
const ACTION_MODIFICAR_DETALLE= 'modificar_detalle';


export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params

        });

    },

    getById(id) {

        return Api().get(`${HEADERURL}${id}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },

    para_comprar(params){
        return Api().get(`${HEADERURL}${ACTION_PARA_COMPRAR}/`, params);
    },

    addDetail(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_ADD_DETAIL}/`, params);

    },

    deleteDetail(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_DELETE_DETAIL}/`, params);

    },

    abrir(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ABRIR}/`);

    },

    cerrar(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_CERRAR}/`);

    },

    anular(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ANULAR}/`);

    },

    pdf(id, params) {

        return Api().post(`${HEADERURL}${id}/${IMPIRMIR_PDF}/`, params);

    },

    autorizarLinea(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_AUTORIZAR_LINEA}/`, params);
    },

    generar_orden_compra(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_GENERAR_ORDEN_COMPRA}/`, params);
    },
    autorizarTodo(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_AUTORIZAR_TODO}/`, params);
    },
    modificar_detalle(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_MODIFICAR_DETALLE}/`, params);
    },
}